var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "alert-path",
    d: "M18.9515 17H1.0485C0.237255 17 -0.265824 16.1523 0.148006 15.4824L9.09961 0.992348C9.50523 0.335884 10.495 0.335884 10.9004 0.992348L19.852 15.4826C20.2658 16.1525 19.7627 17 18.9515 17Z",
    fill: "#0885C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32255 12.2958L8.88702 6.00014C8.84763 5.43024 9.29071 4.93716 9.87666 4.89885C10.4626 4.86054 10.9696 5.29149 11.009 5.86139C11.012 5.90625 11.0116 5.95647 11.009 6.00034L10.5734 12.296C10.4981 13.0506 9.39664 13.0488 9.32255 12.2958Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94788 15.4287C10.4272 15.4287 10.8157 15.0508 10.8157 14.5846C10.8157 14.1185 10.4272 13.7406 9.94788 13.7406C9.46861 13.7406 9.08008 14.1185 9.08008 14.5846C9.08008 15.0508 9.46861 15.4287 9.94788 15.4287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.50a2508ac00ce5a9df0370788cd75bdd.svg";
export { ForwardRef as ReactComponent };